<template>
  <div class="apiget_ponents">
    <el-tabs v-model="activeTab" tab-position="top">
      <el-tab-pane label="动态住宅IP" name="tab1">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <!--
              <div class="content_pane_div_let_div_div">
                <div
                  class="content_pane_div_let_div_divs"
                  :class="{ 'active-border': isActive }"
                  @click="toggleBorder"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/edtc.svg"
                        alt=""
                      />账号额度
                    </div>
                    <div class="zhed_cls_text">
                      剩余额度：
                      <div>0</div>
                    </div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      扣费单价：
                      <div>￥70/G</div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>

                <div
                  class="content_pane_div_let_div_divs"
                  :class="{ 'active-border': isActiveB }"
                  @click="toggleBorderB"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/bytc.svg"
                        alt=""
                      />包月套餐
                    </div>
                    <div class="zhed_cls_text">
                      剩余流量:
                      <div>0M</div>
                    </div>
                    <div class="zhed_cls_text">到期时间:无期限</div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>
              </div>
              -->
              <div class="div_xiala">
                <el-form :model="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <!--
                      <el-form-item label="选择套餐">
                        <el-select
                          v-model="form.package"
                          placeholder="请选择套餐"
                        >
                          <el-option
                            label="账号额度"
                            value="账号额度"
                          ></el-option>
                          <el-option
                            label="包月套餐"
                            value="包月套餐"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      -->
                      <el-form-item label="选择国家地区">
                        <el-select
                            v-model="form.country"
                            placeholder="请选择国家"
                        >
                          <el-option
                              v-for="list in quanqiu"
                              :key="list.code"
                              :label="list.name"
                              :value="list.code"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <!--
                      <el-form-item label="选择州(省)">
                        <el-select
                          v-model="form.package"
                          placeholder="请选择州(省)"
                        >
                          <el-option label="州" value="州"></el-option>
                          <el-option label="省" value="省"></el-option>
                        </el-select>
                      </el-form-item>
                      -->
                    </el-col>

                    <el-col :span="12">

                      <el-form-item label="过期时间">
                        <div style="padding-right: 37px">
                          <el-input-number
                              v-model="form.sessTime"
                              controls-position="right"
                              :min="3"
                              label="过期时间"
                          ></el-input-number>
                        </div>
                      </el-form-item>

                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      class="but_sclj"
                      type="primary"
                      @click="generateLink"
                      >生成指令</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="jkcszj">
                <h2 class="H2_text">
                  <img
                    src="http://apiupss.ppfly.top/images/par_icon.svg"
                    alt=""
                  />
                  接口参数注解
                </h2>
                <h2 class="H3_text">请求参数注解</h2>
                <table class="no-border-table">
                  <thead>
                    <tr class="top_name">
                      <th>参数</th>
                      <th>描述</th>
                      <th>必选</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="top_text">
                      <td>account</td>
                      <td>用户名</td>
                      <td>是</td>
                    </tr>
                    <tr class="top_text">
                      <td>password</td>
                      <td>密码</td>
                      <td>是</td>
                    </tr>
                    <tr class="top_text">
                      <td>session</td>
                      <td>需要固定一个ip时配置，用户自定义随机5-9位数</td>
                      <td>是</td>
                    </tr>
                    <tr class="top_text">
                      <td>res</td>
                      <td>否</td>
                      <td><a href="images/doc/word_code.docx">国家编码</a></td>
                    </tr>
                    <tr class="top_text">
                      <td>sessTime</td>
                      <td>
                        搭配session使用，用于配置ip时效时间，最长不超过120分钟
                      </td>
                      <td>否</td>
                    </tr>

                  </tbody>
                </table>
              </div>

              <div class="dmsl">
                <h2 class="H3_text">接口使用方法</h2>
                <pre class="json-code">
示例：
curl -x proxy.ppfly.xyz:1080 -U "[account]-res-US-session-123123-sessTime-3:[password]" ipinfo.io

                 </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="独享数据中心IP" name="tab2">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="content_pane_div_let_div_div">
                <div
                  class="content_pane_div_let_div_divsB"
                  :class="{ 'active-border': isActiveB }"
                  @click="toggleBorderB"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/jtzz_1.svg"
                        alt=""
                      />独享数据中心IP
                    </div>

                    <div class="zhed_cls_text">
                      当前可用:
                      <div>0个</div>
                    </div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>
              </div>
              <div class="div_xiala">
                <el-form :model="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="选择国家/地区" v-if="shifoudiqu">
                        <el-select
                          v-model="form.country"
                          placeholder="请选择国家"
                        >
                          <el-option
                            v-for="list in quanqiu"
                            :key="list.name"
                            :label="list.name"
                            :value="list.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择国家/地区" v-else>
                        <div>
                          暂未开通, <el-link type="success">立即前往</el-link>
                        </div>
                      </el-form-item>

                      <el-form-item label="账号名">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item label="密码">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="选择IP">
                        <el-select
                          v-model="form.dataFormat"
                          placeholder="请选择IP"
                        >
                          <el-option label="XTX" value="XTX"></el-option>
                          <el-option label="JSON" value="JSON"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择认证账户">
                        <el-select
                          v-model="form.proxyAgreement"
                          placeholder="请选择认证账户"
                        >
                          <el-option
                            label="HTTP/HTTPS"
                            value="HTTPS"
                          ></el-option>
                          <el-option label="SOCKS5" value="SOCKS5"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      class="but_sclj"
                      type="primary"
                      @click="generateLink"
                      >生成链接</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="静态住宅IP" name="tab3">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="content_pane_div_let_div_div">
                <div
                  class="content_pane_div_let_div_divsB"
                  :class="{ 'active-border': isActiveB }"
                  @click="toggleBorderB"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/dxsj_1.svg"
                        alt=""
                      />静态住宅IP
                    </div>

                    <div class="zhed_cls_text">
                      当前可用:
                      <div>0个</div>
                    </div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>
              </div>
              <div class="div_xiala">
                <el-form :model="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="选择国家/地区" v-if="shifoudiqu">
                        <el-select
                          v-model="form.country"
                          placeholder="请选择国家"
                        >
                          <el-option
                            v-for="list in quanqiu"
                            :key="list.name"
                            :label="list.name"
                            :value="list.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择国家/地区" v-else>
                        <div>
                          暂未开通, <el-link type="success">立即前往</el-link>
                        </div>
                      </el-form-item>

                      <el-form-item label="账号名">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item label="密码">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="选择IP">
                        <el-select
                          v-model="form.dataFormat"
                          placeholder="请选择IP"
                        >
                          <el-option label="XTX" value="XTX"></el-option>
                          <el-option label="JSON" value="JSON"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择认证账户">
                        <el-select
                          v-model="form.proxyAgreement"
                          placeholder="请选择认证账户"
                        >
                          <el-option
                            label="HTTP/HTTPS"
                            value="HTTPS"
                          ></el-option>
                          <el-option label="SOCKS5" value="SOCKS5"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      class="but_sclj"
                      type="primary"
                      @click="generateLink"
                      >生成链接</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="动态长效ISP" name="tab4">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="content_pane_div_let_div_div">
                <div
                  class="content_pane_div_let_div_divsB"
                  :class="{ 'active-border': isActive }"
                  @click="toggleBorder"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/edtc.svg"
                        alt=""
                      />账号额度
                    </div>
                    <div class="zhed_cls_text">
                      剩余额度：
                      <div>0</div>
                    </div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      扣费单价：
                      <div>￥0/G</div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>
              </div>
              <div class="div_xiala">
                <el-form :model="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="选择国家/地区" v-if="shifoudiqu">
                        <el-select
                          v-model="form.country"
                          placeholder="请选择国家"
                        >
                          <el-option
                            v-for="list in quanqiu"
                            :key="list.name"
                            :label="list.name"
                            :value="list.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择国家/地区" v-else>
                        <div>
                          暂未开通, <el-link type="success">立即前往</el-link>
                        </div>
                      </el-form-item>

                      <el-form-item label="选择认证账户">
                        <el-select
                          v-model="form.package"
                          placeholder="请选择认证账户"
                        >
                          <el-option
                            label="每次请求更换"
                            value="每次请求更换"
                          ></el-option>
                          <el-option
                            label="指定时效"
                            value="指定时效"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="账号名">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item label="密码">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="代理协议">
                        <el-select
                          v-model="form.proxyAgreement"
                          placeholder="请选择协议"
                        >
                          <el-option
                            label="HTTP/HTTPS"
                            value="HTTPS"
                          ></el-option>
                          <el-option label="SOCKS5" value="SOCKS5"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="ip持续时间(分钟)">
                        <div style="padding-right: 37px">
                          <el-input-number
                            v-model="form.quantity"
                            controls-position="right"
                            :min="1"
                            label="提取数量"
                          ></el-input-number>
                        </div>
                      </el-form-item>

                      <el-form-item label="代理地址">
                        <el-select
                          v-model="form.proxyAgreement"
                          placeholder="请选代理地址"
                        >
                          <el-option
                            label="HTTP/HTTPS"
                            value="HTTPS"
                          ></el-option>
                          <el-option label="SOCKS5" value="SOCKS5"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      class="but_sclj"
                      type="primary"
                      @click="generateLink"
                      >生成链接</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="jkcszj">
                <h2 class="H2_text">
                  <img
                    src="http://apiupss.ppfly.top/images/par_icon.svg"
                    alt=""
                  />
                  接口参数注解
                </h2>
                <h2 class="H3_text">请求参数注解</h2>
                <table class="no-border-table">
                  <thead>
                    <tr class="top_name">
                      <th>参数</th>
                      <th>描述</th>
                      <th>必选</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="top_text">
                      <td>zone</td>
                      <td>代理池标识</td>
                      <td>是</td>
                    </tr>
                    <tr class="top_text">
                      <td>region</td>
                      <td>地区，不填默认全球混播</td>
                      <td>否</td>
                    </tr>
                    <tr class="top_text">
                      <td>session</td>
                      <td>
                        搭配session使用，用于配置ip时效时间，最长不超过120分钟
                      </td>
                      <td>否</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="dmsl">
                <h2 class="H3_text">接口使用方法</h2>
                <pre class="json-code">
zone-代理池标识

                    
[account]-zone-custom:[password]
 示例：
# 混播 一次一换
curl -x proxy.ppfly.xyz:1080 -U "[account]-zone-custom:[password]" ipinfo.io
                    
                  
region−指定地区

                    
[account]-zone-custom-region-us:[password]
region-us 美国
示例：
# 访问美国
curl -x proxy.ppfly.xyz:1080 -U "[account]-zone-custom-region-us:[password]" ipinfo.io
                    
                  
session−固定一个出口ip

                    
用于指定想要固定一个出口ip一段时间,不指定默认5分钟
[account]-zone-custom-region-kr-session-b5b36885cad:[password]
示例：
 # 固定出口ip
curl -x proxy.ppfly.xyz:1080 -U "[account]-zone-custom-session-b5b36885cad:[password]" ipinfo.io
                    
                  
sessTime-指定一个出口ip最长持续时间 最高 360分钟

                    
与 session 搭配使用，用于指定固定的出口ip存活时间
[account]-zone-custom-region-kr-session-b5b36885cad-sessTime-20:[password]
sessTime-5 5分钟
sessTime-10 10分钟
sessTime-30 30分钟
示例：
# 固定出口ip 存活20分钟
curl -x proxy.ppfly.xyz:1080 -U "[account]-zone-custom-session-b5b36885cad-sessTime-20:[password]" ipinfo.io
                    
                  
                                                </pre
                >
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="动态数据中心" name="tab5">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="content_pane_div_let_div_div">
                <div
                  class="content_pane_div_let_div_divsB"
                  :class="{ 'active-border': isActive }"
                  @click="toggleBorder"
                >
                  <div>
                    <div class="zhed_cls">
                      <img
                        src="http://apiupss.ppfly.top/images/edtc.svg"
                        alt=""
                      />账号额度
                    </div>
                    <div class="zhed_cls_text">
                      剩余额度：
                      <div>0</div>
                    </div>
                  </div>
                  <div class="div_zhed_cls_text">
                    <div class="zhed_cls_text">
                      扣费单价：
                      <div>￥0/G</div>
                    </div>
                  </div>
                  <div>
                    <el-button plain>立即充值</el-button>
                  </div>
                </div>
              </div>
              <div class="div_xiala">
                <el-form :model="form" label-width="120px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="选择国家/地区" v-if="shifoudiqu">
                        <el-select
                          v-model="form.country"
                          placeholder="请选择国家"
                        >
                          <el-option
                            v-for="list in quanqiu"
                            :key="list.name"
                            :label="list.name"
                            :value="list.name"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="选择国家/地区" v-else>
                        <div>
                          暂未开通, <el-link type="success">立即前往</el-link>
                        </div>
                      </el-form-item>

                      <el-form-item label="选择认证账户">
                        <el-select
                          v-model="form.package"
                          placeholder="请选择认证账户"
                        >
                          <el-option
                            label="每次请求更换"
                            value="每次请求更换"
                          ></el-option>
                          <el-option
                            label="指定时效"
                            value="指定时效"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="账号名">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item label="密码">
                        <div class="input_div">
                          <el-input
                            v-model="form.quantity"
                            controls-position="right"
                          ></el-input>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="代理地址">
                        <el-select
                          v-model="form.proxyAgreement"
                          placeholder="请选代理地址"
                        >
                          <el-option
                            label="HTTP/HTTPS"
                            value="HTTPS"
                          ></el-option>
                          <el-option label="SOCKS5" value="SOCKS5"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="IP时效">
                        <el-select
                          v-model="form.package"
                          placeholder="请选择IP时效"
                        >
                          <el-option
                            label="每次请求更换"
                            value="每次请求更换"
                          ></el-option>
                          <el-option
                            label="指定时效"
                            value="指定时效"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      class="but_sclj"
                      type="primary"
                      @click="generateLink"
                      >生成链接</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="jkcszj">
                <h2 class="H2_text">
                  <img
                    src="http://apiupss.ppfly.top/images/par_icon.svg"
                    alt=""
                  />
                  接口参数注解
                </h2>
                <h2 class="H3_text">请求参数注解</h2>
                <table class="no-border-table">
                  <thead>
                    <tr class="top_name">
                      <th>名称</th>
                      <th>类型</th>
                      <th>必选</th>
                      <th>说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="top_text">
                      <td>package</td>
                      <td>String</td>
                      <td>是</td>
                      <td>选择的套餐</td>
                    </tr>
                    <tr class="top_text">
                      <td>quantity</td>
                      <td>Number</td>
                      <td>是</td>
                      <td>提取的数量</td>
                    </tr>
                    <tr class="top_text">
                      <td>dataFormat</td>
                      <td>String</td>
                      <td>否</td>
                      <td>返回的数据格式</td>
                    </tr>
                    <tr class="top_text">
                      <td>country</td>
                      <td>String</td>
                      <td>是</td>
                      <td>选择的国家地区</td>
                    </tr>
                    <tr class="top_text">
                      <td>proxyAgreement</td>
                      <td>String</td>
                      <td>否</td>
                      <td>代理协议</td>
                    </tr>
                    <tr class="top_text">
                      <td>separator</td>
                      <td>String</td>
                      <td>否</td>
                      <td>数据分隔符</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="jkcszj">
                <h2 class="H3_text">返回参数注释</h2>
                <table class="no-border-table">
                  <thead>
                    <tr class="top_name">
                      <th class="top_name_th">名称</th>
                      <th class="top_name_th">类型</th>
                      <th class="top_name_th">说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="top_text">
                      <td>IP</td>
                      <td>int</td>
                      <td>IP地址</td>
                    </tr>
                    <tr class="top_text">
                      <td>PORT</td>
                      <td>int</td>
                      <td>端口号</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="dmsl">
                <h2 class="H3_text">代码返回示例</h2>
                <pre class="json-code">
                                     {
                                         <span>"code"</span>: <span class="lan_">0</span>,
                                         <span>"success"</span>: <span class="hong_">true</span>,
                                         <span>"msg"</span>: <span class="lan_">"0"</span>,
                                         <span>"data"</span>: [
                                                    {<span>"ip"</span>: <span class="lan_">"47.244.192.12"</span>, <span>"port"</span>: <span class="lan_">16098</span>},
                                                    {<span>"ip"</span>: <span class="lan_">"47.244.192.12"</span>, <span>"port"</span>: <span class="lan_">15698</span>}
                                                ]
                                     }
                                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div class="apiget_ponents_ret">
        <div class="text_top_text">API链接</div>
        <!-- 替换后的输入区域 -->
        <textarea
            class="text_top_H_input"
            v-model="generatedUrl"
            placeholder="生成的地址将显示在这里"
            readonly
        ></textarea>

        <div class="div_buts_top">
          <el-button @click="copyLink">复制链接</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      generatedUrl:"",
      shifoudiqu: false,
      maindiv: "",
      activeTab: "tab1",
      isActive: false,
      isActiveB: false,
      form: {
        package: "",
        quantity: "",
        sessTime: "",
        dataFormat: "",
        country: "any",
        proxyAgreement: "",
        separator: "",
      },
      quanqiu: [
        { name: "全球混播",code:"any" },
        { name: "美国" ,code:"US"  },
        { name: "日本" ,code:"JP" },
        { name: "中国香港",code:"HK"  },
        { name: "更多",code:"参考文档"  },
      ],
    };
  },
  created() {
    // 在组件创建时获取路由参数
    // this.userId = this.$route.params.id;
  },
  components: {},
  mounted() {},
  methods: {
    onclick(name) {
      console.log();
      this.maindiv = name;
    },
    toggleBorder() {
      this.isActive = true; // 切换边框状态
      this.isActiveB = false;
    },
    toggleBorderB() {
      this.isActiveB = true; // 切换边框状态
      this.isActive = false;
    },
    generateLink() {
      // 处理生成链接的逻辑
      const token_tesp = this.$cookies.get("userdata");
      if (token_tesp && token_tesp.data && token_tesp.data.user_data) {
        // 确保 token_tesp, token_tesp.data, 和 token_tesp.data.user_data 都存在
        this.username = token_tesp.data.user_data.username || "用户名";
        this.password = token_tesp.data.user_data.password || "密码";
      } else {
        // 如果 userdata 不存在，则设置默认值
        this.username = "用户名";
        this.password = "密码";
      }
      var randsessionid = Math.floor(10000000 + Math.random() * 90000000);

      var strurl = "curl -x socks5://proxy.ppfly.xyz:1080 -U "+this.username+"-res-"+this.form.country+"-session-"+randsessionid+"-sessTime-"+ this.form.sessTime +":"+ this.password +" ip.me";
      //alert(strurl)
      this.generatedUrl = strurl;

      console.log("生成链接:", this.form);
    },
    copyLink() {
      if (!this.generatedUrl) {
        alert('没有链接可复制');
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = this.generatedUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      alert('链接已复制到剪贴板');
    }
  },
};
</script>
<style>
.input_div {
  width: 215px;
  margin-left: 60px;
}
.zisei {
  background-color: #6327d3;
  border: none;
}
.zisei:hover {
  background-color: #542ca0;
}
.apiget_ponents {
  /* position: relative; */
}
.apiget_ponents_ret {
  height: 770px;
  width: 600px;
  position: absolute;
  background-color: #edf3fc;
  right: 0px;
  z-index: 3;
}
.getapi {
}

.getapi_body {
}

.sidebar {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
}

.sidebar_ret {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
  position: absolute;
  left: 1280px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.el-menu-item {
  border-radius: 15px;
  text-align: left;
}

.title_img {
  text-align: left;
}

.sidebar {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
  /* overflow-y: scroll; */
  height: 800px;
}

.main-content_pane_div {
  display: flex;
  justify-content: space-between;
}

.content_pane_div_let {
}

.content_pane_div_let_div_div {
  display: flex;
  justify-content: space-around;
  width: 900px;
  padding: 10px;
}

.content_pane_div_let_div_divs {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 400px;
}

.content_pane_div_let_div_divsB {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 1400px;
}

.active-border {
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* 点击后添加的边框样式 */
}

.content_pane_div_let_div_divs:nth-child(1) {
  margin-right: 10px;
}

.content_pane_div_let_div_divs > div:nth-child(1) {
}

.content_pane_div_let_div_divs > div:nth-child(2) {
}

.content_pane_div_let_div_divs > div:nth-child(3) {
}

.zhed_cls {
  text-align: left;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #18181b;
}

.div_zhed_cls_text {
  margin-top: 10px;
}

.zhed_cls_text {
  font-size: 14px;
  color: #737791;
  display: flex;
  justify-content: space-between;
}

.zhed_cls_text > div {
  font-size: 16px;
  color: #000;
  line-height: 22px;
}

.sidebar {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.div_xiala {
  background-color: #edf3fc;
  /* 表单背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.but_sclj {
  width: 207px;
  height: 38px;
  background: #1a73e8;
  box-shadow: 0 11px 10px 0 rgba(29, 104, 250, 0.13);
  border-radius: 6px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  color: #edf3fc;
  cursor: pointer;
  margin-right: 150px;
  margin-top: 50px;
}

.sidebar {
  background-color: #edf3fc;
  /* 左侧导航栏背景色 */
  padding: 20px;
  /* 内边距 */
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.jkcszj {
  background-color: #edf3fc;
  /* 接口参数注解背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.jkcszj h2 {
  margin-bottom: 20px;
  /* 标题下边距 */
}

.no-border-table {
  width: 100%;
  border-collapse: collapse;
  /* 合并边框 */
}

.no-border-table th,
.no-border-table td {
  border: none;
  /* 无边框 */
  padding: 10px;
  /* 单元格内边距 */
  text-align: left;
  /* 左对齐 */
}

.no-border-table th {
  background-color: #f0f0f0;
  /* 表头背景色 */
}

.H2_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 16px;
  color: #18181b;
  display: flex;
  align-items: center;
  margin-left: -25px;
}

.H3_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 13px;
  color: #505053;
  display: flex;
  align-items: center;
}

.top_name {
  font-size: 16px;
  font-weight: 700;
  background: #f0f9ff;
  border-radius: 7px;
  height: 48px;
  border-bottom: none;
}

.top_name_th {
  font-size: 13px;
}

.top_text {
  font-size: 14px;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 14px;
  font-weight: 400;
  color: #444a6d;
  text-align: center;
}

.json-code {
  text-align: left;
  /* 使文本左对齐 */
  background-color: #f8f8f8;
  /* 设置背景颜色 */
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  overflow: auto;
  /* 处理溢出内容 */
  white-space: pre-wrap;
  /* 允许换行 */
  font-family: SimHei;
  /* 使用等宽字体 */
  font-size: 15px;
}

.lan_ {
  color: #569fcf;
}

.hong_ {
  color: #be470f;
}
.div_dome {
  background-color: #1a73e8;
}
.text_top_H {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #f64e60;
  line-height: 16px;
  text-align: left;
}
.text_top_text {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #18181b;
  line-height: 20px;
  margin-top: 30px;
  margin-bottom: 6px;
  text-align: left;
  margin-left: 5px;
}
.div_buts_top {
}

.text_top_H_input {
  width: 100%;
  height: 80px;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none; /* 禁止拖动大小 */
  box-sizing: border-box;
  margin-bottom: 10px;
}
</style>